/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const wrapDataAsUrlSearchParamMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { originalData = {} } = req;
    const urlSearchParams = new URLSearchParams();

    (Object.keys(originalData)).forEach((key) => {
        urlSearchParams.append(key, originalData[key]);
    });

    req.data = urlSearchParams;
    next();
};
